import { Component, OnInit } from '@angular/core';
import { TimesheetObsService } from '@app/main/time-sheet/services/timesheet-obs.service';
import { NgxSpinnerTextService } from '@app/shared/ngx-spinner-text.service';
import { AppConsts } from '@shared/AppConsts';
import { CompanyProfileServiceProxy, ProfileServiceProxy, SessionServiceProxy, TimesheetServiceProxy } from '@shared/service-proxies/service-proxies';
import { RootService } from 'root.service';

@Component({
    selector: "app-root",
    template: ` <router-outlet></router-outlet>

    <ngx-spinner template=" " bdColor = "rgba(0,0,0,0)" size="medium" color="#5ba7ea" > <p>{{getSpinnerText()}}</p></ngx-spinner> `,
})
export class RootComponent {
    ngxSpinnerText: NgxSpinnerTextService;

    constructor(
        _ngxSpinnerText: NgxSpinnerTextService,
        private _companyProfileServiceProxy: CompanyProfileServiceProxy,
        private _tsProxy: TimesheetServiceProxy,
        private _sessionServiceProxy: SessionServiceProxy,
        private _rootService: RootService,
        private _profileService: ProfileServiceProxy
    ) {
        this.ngxSpinnerText = _ngxSpinnerText;
        this.setTimesheetPermissions();
        this.setDateFormat();
    }

    getSpinnerText(): string {
        return this.ngxSpinnerText.getText();
    }

    async setDateFormat() {
        if (abp.session.userId != null) {
            if (abp.session.tenantId) {
                AppConsts.companyDetails = await this._companyProfileServiceProxy.getCompanyProfileDetailsForEditView(abp.session.tenantId).toPromise();
            }
            else {
                AppConsts.companyDetails = await this._companyProfileServiceProxy.getCompanyProfileDetailsForEditView(undefined).toPromise();

            }
            AppConsts.dateFormatId = !AppConsts.dateFormatId ? await AppConsts.companyDetails?.dateFormat : AppConsts.dateFormatId;
        }
        if (abp.session.userId != null) { AppConsts.myProfileInfo = !AppConsts.myProfileInfo ? await await this._profileService.myProfileInfo().toPromise() : AppConsts.myProfileInfo }
    }

    async setTimesheetPermissions() {
        //if (abp.session.userId != null) {          
        //    AppConsts.isCurrentUserTimesheetApprover = await this._tsProxy.isTimeSheetApprovar(abp.session.userId).toPromise();
        //}
        // Commented to remove the duplicate API call getCurrentLoginInformations()

        // AppConsts.userRoleArray = (await this._sessionServiceProxy.getCurrentLoginInformations().toPromise()).user?.userRole.map((r) =>
        //     r.toLowerCase()
        // );
        if (AppConsts.userRoleArray) this._rootService.timesheetPersmissionInfoSet.next(1);
    }
}
